import { Link } from 'react-router-dom';

// Footer component
export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollItems = [
    { label: 'CONCEPT', href: '#concept' },
    { label: 'USE CASE', href: '#experience' },
    { label: 'FLOW', href: '#flow' },
    { label: 'ABOUT US', href: '#about' },
    { label: 'CONTACT', href: '#contact' },
  ];

  return (
    <footer className="w-full bg-[#f5f3ef] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 pb-12 border-b border-stone-200">
          {/* Brand */}
          <div className="flex flex-col gap-5">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/c91283b5457e986239e622bbc2102529/9159435334e08634e35325bf0424e9e8.jpeg"
                alt="AMYMAISON"
                className="h-30 w-auto object-contain object-left"
              />
            </Link>
            <div className="flex flex-col gap-1">
              <p className="text-stone-500 text-xs leading-relaxed">
                セントマーケティングカンパニー
              </p>
              <p className="text-stone-500 text-xs leading-relaxed">
                株式会社AMYMAISON
              </p>
            </div>
            <div className="flex items-center gap-4 mt-2">
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-stone-300 text-stone-500 hover:text-stone-900 hover:border-stone-500 transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="https://x.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-stone-300 text-stone-500 hover:text-stone-900 hover:border-stone-500 transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-x-line text-sm" />
              </a>
            </div>
          </div>

          {/* Menu */}
          <div className="flex flex-col gap-4">
            <p className="text-xs tracking-widest text-stone-400 font-medium">MENU</p>
            {scrollItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleScroll(item.href)}
                className="text-xs tracking-widest text-stone-500 hover:text-stone-900 transition-colors duration-300 cursor-pointer text-left underline-offset-4 hover:underline whitespace-nowrap w-fit"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/column"
              className="text-xs tracking-widest text-stone-500 hover:text-stone-900 transition-colors duration-300 cursor-pointer underline-offset-4 hover:underline whitespace-nowrap w-fit"
            >
              COLUMN
            </Link>
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-4">
            <p className="text-xs tracking-widest text-stone-400 font-medium">COMPANY</p>
            <a href="/company" className="text-xs tracking-widest text-stone-500 hover:text-stone-900 transition-colors duration-300 cursor-pointer underline-offset-4 hover:underline whitespace-nowrap w-fit">
              会社概要 (Company)
            </a>
            <Link to="/privacy" className="text-xs tracking-widest text-stone-500 hover:text-stone-900 transition-colors duration-300 cursor-pointer underline-offset-4 hover:underline whitespace-nowrap w-fit">
              プライバシーポリシー (Privacy Policy)
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-400 tracking-wide">
            Copyright &copy; AMYMAISON All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
